import axios from '../axios'

/*
 * 会员管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/admin/dept/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/admin/dept/delete',
        method: 'post',
        data
    })
}
// 查询
export const selectByPage = (data) => {
    return axios({
        url: '/admin/member/selectByPage',
        method: 'post',
        data
    })
}

//查询会员等级
export const selectGradeByPage = (data) => {
    return axios({
        url: '/admin/level/selectByPage',
        method: 'post',
        data
    })
}

// 粉丝列表查询
export const selectFansPage = (data) => {
    return axios({
        url: '/admin/member/selectFansPage',
        method: 'post',
        data
    })
}

// 批量保存会员信息
export const batchSave = (data) => {
    return axios({
        url: '/admin/level/batchSave',
        method: 'post',
        data
    })
}

export const selectById = (params) => {
    return axios({
        url: '/admin/member/selectById',
        method: 'get',
        params
    })
}

export const selectByNo = (params) => {
    return axios({
        url: '/admin/member/selectByNo',
        method: 'get',
        params
    })
}

export const memberMonthCount = (params) => {
    return axios({
        url: '/admin/member/memberMonthCount',
        method: 'get',
        params
    })
}

export const memberCommissionCount = (params) => {
    return axios({
        url: '/admin/commissionCount/memberCommissionCount',
        method: 'get',
        params
    })
}

export const monthCountSelectByPage = (data) => {
    return axios({
        url: '/admin/commissionCount/selectByPage',
        method: 'post',
        data
    })
}

export const settlementCommission = (data) => {
    return axios({
        url: '/admin/member/settlementCommission',
        method: 'post',
        data
    })
}

export const giftAmount = (data) => {
    return axios({
        url: '/admin/member/giftAmount',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/member.js